import React from 'react';

export default function CompressedImage({
  webp,
  jxr,
  jpf,
  src,
  alt,
  ...props
}) {
  const imgName = src.substr(0, src.indexOf('.'));
  const extension = src.substr(src.indexOf('.') + 1);
  const imgType = extension === 'jpg' ? 'jpeg' : extension;

  console.log({ imgName, extension });

  return (
    <picture style={props.style}>
      {webp && <source srcSet={`${imgName}.webp`} type='image/webp' />}
      {jxr && <source srcSet={`${imgName}.jxr`} type='image/jxr' />}
      {jpf && <source srcSet={`${imgName}.jpf`} type='image/jp2' />}
      <source srcSet={src} type={`image/${imgType}`} />
      <img src={src} alt={alt} {...props} />
    </picture>
  );
}
